import { RootState } from 'editor/src/store/index';

import getSpread from './getSpread';

const getSpreadPage = (state: RootState, spreadIndex: number, pageIndex: number) =>
  getSpread(state, spreadIndex)?.pages[pageIndex];

export default getSpreadPage;
